import React from "react";
import { EMPTY } from "../../common/constant.js";
import PropTypes from "prop-types";
import { intersection } from "lodash";

const Visible = ({ children, roles, userRoles, as, className }) => {
  const userHasAppropriateRole = !roles || !roles.length || intersection(roles, userRoles).length > EMPTY;
  const CustomTag = as || "div";

  if (className) {
    return <CustomTag className={className}>{userHasAppropriateRole && children}</CustomTag>;
  }

  return as ? <CustomTag>{userHasAppropriateRole && children}</CustomTag> : <>{userHasAppropriateRole && children}</>;
};

Visible.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.array.isRequired,
  userRoles: PropTypes.array.isRequired
};

export default Visible;
